import React from "react";
import classes from "./Tabs.module.css";

export default function Tabs({
  categories,
  selectedCategory,
  onSelectCategory,
}) {
  return (
    <div className={classes.tabsWrapper}>
      {categories.slice(0, 3).map((cat, i) => {
        const label = typeof cat === "string" ? cat : cat.label || cat.value;
        const value = typeof cat === "string" ? cat : cat.value;
        return (
          <button
            key={value ?? i}
            className={`${classes.tabButton} ${
              selectedCategory === value ? classes.active : ""
            }`}
            onClick={() => onSelectCategory(value)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
